<template>
	<div>
		<!--confirm -- -->
		<v-card class="mx-auto elevation-2" style="max-width: 500px" :loading="apiRequest">
			<v-card-title class="text-center headline font-weight-black">
				<v-spacer></v-spacer>Confirm Sign up
				<v-spacer></v-spacer>
			</v-card-title>
			<v-card-subtitle class="text-center">Please check your email for a code to confirm your signup.</v-card-subtitle>
			<v-card-subtitle v-if="resendConfirmCodeError" class="text-center red--text">Error sending code. Please check your email provided.</v-card-subtitle>
			<v-card-subtitle v-if="errorconfirming" class="text-center red--text mt-0 pt-0">Please check your email and code.</v-card-subtitle>

			<!--v-card-subtitle
        error
        class="error text-center"
        v-show="generalError.length > 0"
        v-for="message in generalError"
        :key="message"
      >{{message}}</v-card-subtitle-->

			<v-form ref="form" v-model="valid" class="pa-4 pt-6" lazy-validation>
				<v-text-field v-model="email" label="Email Address" outlined :rules="emailRules" required></v-text-field>

				<v-text-field
					class="mb-2"
					v-model="confirmcode"
					label="Confirmation Code"
					outlined
					:rules="codeRules"
					required
					persistent-hint
					hint="Check your spam folder if code not received."
				></v-text-field>

				<p v-if="valid" align="center">Please login after confirming your account.</p>

				<v-card-actions>
					<v-spacer />
					<v-btn :loading="apiRequest" :disabled="!valid" depressed large rounded color="primary" class="mb-2 pa-5 text-none" @click="confirmSignUp"
						>Confirm Sign up
						<v-icon right>mdi-arrow-right</v-icon>
					</v-btn>
					<v-spacer />
				</v-card-actions>
				<v-spacer />
			</v-form>
			<!-- end confirm signup form -->

			<p align="center" class="mt-2 pb-5">
				Lost your code?
				<a @click="resendConfirmationCode()">Resend Code</a>
			</p>

			<p v-if="coderesent" class="green--text pa-2" align="center">code successfully resent</p>
		</v-card>
	</div>
</template>

<script>
import { Auth } from 'aws-amplify';
// import { AmplifyEventBus } from 'aws-amplify-vue';
import store from '@/store';

export default {
	name: 'UserConfirmSignupForm',
	props: ['id'],
	data: () => ({
		valid: false,
		apiRequest: false,

		confirmcode: '',

		//
		email: null,
		errorconfirming: false,
		resendConfirmCodeError: false,
		coderesent: false,
	}),
	computed: {
		emailRules() {
			return [v => !!v || 'E-mail is required', v => /.+@.+/.test(v) || 'E-mail must be valid'];
		},
		codeRules() {
			return [v => !!v || 'Code is required', v => (v && v.length === 6) || 'Code must be 6 digits'];
		},
	},
	mounted() {
		if (this.$route.query.username) this.email = this.$route.query.username;
		else this.email = store.getters.getUsername;
	},
	methods: {
		async confirmSignUp() {
			this.apiRequest = true;
			this.errorconfirming = false;
			Auth.confirmSignUp(this.email.toLowerCase().trim(), this.confirmcode.trim())
				.then(() => {
					window.sendinblue.identify(this.email.toLowerCase(), {
						EMAIL_VERIFIED: true,
					});
					this.apiRequest = false;
					this.redirect();
				})
				.catch(err => {
					this.apiRequest = false;
					this.errorconfirming = true;

					this.generalError = [];
					this.generalError.push(err);
					window.scrollTo(0, 0);
				});
		},

		resendConfirmationCode() {
			this.$router.push('/resend-confirmation-code');
		},

		redirect() {
			const { returnUrl } = this.$route.query;
			if (returnUrl) {
				this.$router.push(returnUrl);
			} else {
				this.$router.push(`/email-confirmed-signin?email=${this.email}`);
			}
		},
	},
};
</script>
